import React from 'react'
import Logo from '../../assets/images/ORIGINS-DIRECT.png'
import originsSystemsLogo from '../../assets/images/oscolored.png'
import openRxLogoPng from '../../assets/images/open-rx-logo-png.png'
import { useBranding } from '../../contexts/BrandingContext'

const AuthLayout = ({ children, isLoading }) => {
  const { isGroupMode, logo, loginBackground } = useBranding()

  const logoSrc = isGroupMode ? (logo || openRxLogoPng) : Logo
  const showLoginBackground = isGroupMode && !!loginBackground

  return (
    <>
      {isLoading ? (
        <div className='loading-container dark:bg-dark'>
          <span className='spinner'></span>
        </div>
      ) : (
        <div className={`auth-layout p-1 ${isGroupMode ? 'auth-layout-group-mode' : ''}`}>
          {/* Left Side (Fixed) */}
          <div
            className={`left-side ${showLoginBackground ? 'has-login-background' : ''}`}
            style={
              showLoginBackground
                ? { '--brand-login-background': `url(${JSON.stringify(loginBackground)})` }
                : undefined
            }
          >
            <div className='overlay'></div>

            {/* Center the logo */}
            <div className='logo-container'>
              <img
                src={logoSrc}
                alt='Logo'
                className='logo'
                style={{ width: '9rem' }}
              />
            </div>

            {/* Subsidiary info - hide when in group mode */}
            {!isGroupMode && (
              <div className='subsidiary-container'>
                <p>Subsidiary of</p>
                <img
                  src={originsSystemsLogo}
                  alt='originsSystemsLogo'
                  className='logo-two'
                />
              </div>
            )}
          </div>

          <div className='right-side'>
            <div className='content'>{children}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default AuthLayout
